import internalApiClient from '../../../../../shared/util/api/internalApiClient';

export enum ValidationStatus {
    Valid = 0,
    CvrInvalid = 1,
    CvrInUse = 2,
    GlnInvalid = 3,
    NotEligibleForFreeGln = 4,
    Mismatch = 100,
}

export interface ValidationResultDto {
    cvr: string;
    officialCompanyName?: string;
    status: ValidationStatus;
}

export default async function validateCompanyForReception(
    cvr: string,
    currentCompanyName: string,
    registerGln: boolean,
    ignoreInUse: boolean
): Promise<ValidationResultDto> {
    const validationResult: ValidationResultDto = (
        await internalApiClient.get(
            `/edocuments/validate-for-reception?cvr=${cvr}&registerGln=${registerGln}&ignoreDuplicateCvr=${ignoreInUse}`
        )
    ).data;
    validationResult.cvr = cvr;

    if (validationResult.status === ValidationStatus.Valid && validationResult.officialCompanyName !== currentCompanyName) {
        validationResult.status = ValidationStatus.Mismatch;
    }

    return validationResult;
}
